// extracted by mini-css-extract-plugin
export var chevron = "_jf-4";
export var chevronExpanded = "_jf-5";
export var row = "_jf-0";
export var rowBody = "_jf-6";
export var rowDescription = "_jf-7";
export var rowHeader = "_jf-1";
export var rowTitle = "_jf-2";
export var rowTitleComplete = "_jf-3";